$(document).ready(function() {
  $('.btn-copy-code').click(function() {
      var discountCode = $('.discount-code-input').text();
      navigator.clipboard.writeText(discountCode).then(function() {
          // 显示Toast通知
          var x = $('#toastCustom');
          x.text('The discount code has been copied to the pasteboard!');
          x.addClass('show');
          setTimeout(function(){ x.removeClass('show'); }, 3000); // 3秒后隐藏
      }, function(err) {
          console.error('Failed to copy discount code:', err);
      });
  });

  if ($('.countdown-timeline').length) {
      var targetDate = new Date($('.countdown-timeline').attr('data-time-set')).getTime();
      
      // Update the countdown every 1 second
      var countdownInterval = setInterval(function() {
          // Get the current time
          var now = new Date().getTime();
          
          // Calculate the difference
          var timeDifference = targetDate - now;
          
          // Calculate days, hours, minutes, and seconds
          var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
          
          // Add leading zeros if the value is less than 10
          days = days < 10 ? '0' + days : days;
          hours = hours < 10 ? '0' + hours : hours;
          minutes = minutes < 10 ? '0' + minutes : minutes;
          seconds = seconds < 10 ? '0' + seconds : seconds;
          
          // Display the result in the respective HTML elements
          $('.date-span.days').text(days);
          $('.date-span.hours').text(hours);
          $('.date-span.minutes').text(minutes);
          $('.date-span.seconds').text(seconds);
          
          // If the countdown is finished, clear the interval
          if (timeDifference < 0) {
              clearInterval(countdownInterval);
              $('.date-span.days, .date-span.hours, .date-span.minutes, .date-span.seconds').text('00');
               $('.discount-banner').css('display','none');
          }
      }, 1000);
  }

  $('.whisper-button').on('click', function() {
    $('.image-off-bg, .image-on-bg, .whisper-button, .content-switch').toggleClass('active');
  });
  
  $('.product-page-hidden-content-section .btn.learn-more').on('click', function() {
    var $section = $('.product-page-hidden-content-section .hidden-content-container');
    $(this).toggleClass('active');
    $('.product-page-hidden-content-section .page-width').toggleClass('active'); 
    
    if ($section.hasClass('active')) {
        // If active, collapse it
        $section.removeClass('active').animate({ height: 0 }, 500, function() {
        });
    } else {
        // If not active, expand it
        var fullHeight = $section.prop('scrollHeight');
        $section.addClass('active').animate({ height: fullHeight }, 500, function() {
        });
    }
    
    setTimeout(function() {
        $('.product-page-hidden-content-section .page-width .right-content-container .description').toggleClass('active'); 
    }, 200);
  });

  if ($('.product-page-video-with-slider-section').length) {
      $('.product-page-video-with-slider-section .btn.learn-more').on('click', function() {
          var $button = $(this);
          
          // Prevent multiple clicks during animation
          if ($button.hasClass('disabled')) return;
          $button.addClass('disabled');
      
          var $section = $('.product-page-video-with-slider-section .content-slider[data-section=' + $button.attr('data-section') + ']');
      
          if ($section.hasClass('active')) {
              // If active, collapse it
              $section.removeClass('active').animate({ height: 0 }, 500, function() {
                  $button.removeClass('active disabled'); // Re-enable button after animation
              });
          } else {
              // If not active, expand it
              var fullHeight = $section.prop('scrollHeight');
              $section.addClass('active').animate({ height: fullHeight }, 500, function() {
                  $button.addClass('active').removeClass('disabled'); // Re-enable button after animation
              });
      
              // After expanding, scroll to the section
              $('html, body').animate({
                  scrollTop: $section.offset().top - 30
              }, 200);
          }
      });
  

      $('.product-page-video-with-slider-section .button-close').on('click', function() {
        var $section = $('.product-page-video-with-slider-section .content-slider[data-section=' + $(this).attr('data-section') + ']');

        if ($section.hasClass('active')) {
            // If active, collapse it
            $section.removeClass('active').animate({ height: 0 }, 500);
            $('.product-page-video-with-slider-section .btn.learn-more[data-section=' + $(this).attr('data-section') + ']').removeClass('active');
            
            // After expanding, scroll to the section
            $('html, body').animate({
                scrollTop: $('.product-page-video-with-slider-section .main-section-container[data-section=' + $(this).attr('data-section') + ']').offset().top - 30
            }, 200);
        }

      });
  }
  
    if ($('.product-page-compatible-section').length) {
          $('.product-page-compatible-section .btn.learn-more').on('click', function() {
              var $button = $(this);
              
              // Prevent multiple clicks during animation
              if ($button.hasClass('disabled')) return;
              $button.addClass('disabled');
          
              var $section = $('.product-page-compatible-section .lower-container');
          
              if ($section.hasClass('active')) {
                  // If active, collapse it
                  $section.removeClass('active').animate({ height: 0 }, 200, function() {
                      $button.removeClass('active disabled'); // Re-enable button after animation
                  });
              } else {
                  // If not active, expand it
                  var fullHeight = $section.prop('scrollHeight');
                  $section.addClass('active').animate({ height: fullHeight }, 200, function() {
                      $button.addClass('active').removeClass('disabled'); // Re-enable button after animation
                  });
          
                setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: $section.offset().top - 30
                    }, 200);
                }, 300); // Adjust delay as needed
              }
          });
        
          $('.product-page-compatible-section .button-close').on('click', function() {
            var $section = $('.product-page-compatible-section .lower-container');
    
            if ($section.hasClass('active')) {
                // If active, collapse it
                $section.removeClass('active').animate({ height: 0 }, 200);
                $('.product-page-compatible-section .btn.learn-more').removeClass('active');
                
                setTimeout(() => {
                    $('html, body').animate({
                      scrollTop: $('.product-page-compatible-section').offset().top - 30
                    }, 200);
                }, 300); // Adjust delay as needed
            }
    
          });
      }
  if ($('.product-page-image-with-slider-section').length) {
      $('.product-page-image-with-slider-section .btn.learn-more').on('click', function() {
          var $button = $(this);
          
          // Prevent multiple clicks during animation
          if ($button.hasClass('disabled')) return;
          $button.addClass('disabled');
      
          var $section = $('.product-page-image-with-slider-section .content-slider[data-section=' + $button.attr('data-section') + ']');
      
          if ($section.hasClass('active')) {
              // If active, collapse it
              $section.removeClass('active').animate({ height: 0 }, 500, function() {
                  $button.removeClass('active disabled'); // Re-enable button after animation
              });
          } else {
              // If not active, expand it
              var fullHeight = $section.prop('scrollHeight');
              $section.addClass('active').animate({ height: fullHeight }, 500, function() {
                  $button.addClass('active').removeClass('disabled'); // Re-enable button after animation
              });
      
              // After expanding, scroll to the section
              $('html, body').animate({
                  scrollTop: $section.offset().top - 30
              }, 200);
          }
      });
  

      $('.product-page-image-with-slider-section .button-close').on('click', function() {
        var $section = $('.product-page-image-with-slider-section .content-slider[data-section=' + $(this).attr('data-section') + ']');

        if ($section.hasClass('active')) {
            // If active, collapse it
            $section.removeClass('active').animate({ height: 0 }, 500);
            $('.product-page-image-with-slider-section .btn.learn-more[data-section=' + $(this).attr('data-section') + ']').removeClass('active');
            
            // After expanding, scroll to the section
            $('html, body').animate({
              scrollTop: $('.product-page-image-with-slider-section .main-section-container[data-section=' + $(this).attr('data-section') + ']').offset().top - 30
          }, 200);
        }

      });
  }

  if ($('.product-page-image-scrollable-section').length) {
    $('.product-page-image-scrollable-section .btn.learn-more').click(function(){
      var $section = $('.product-page-image-scrollable-2-section');

      // After expanding, scroll to the section
      $('html, body').animate({
          scrollTop: $section.offset().top - 30
      }, 200);
      
    })

  }
  
  if ($('.product-buy-now-button').length) {
      $('.product-buy-now-button').click(function() {
          let $this = $(this);
          if ($this.data('clicked')) return; // Prevent multiple clicks
  
          $this.data('clicked', true); // Mark as clicked
          $('#more-payment-options-link').click();
  
          setTimeout(() => {
              $this.removeData('clicked'); // Allow clicking again after delay
          }, 1000); // Adjust delay as needed
      });
  }
  if ($('.product-page-nav-header-section').length) {
      $('.product-page-nav-header-section .btn.buy-now').click(function() {
          let $this = $(this);
          if ($this.data('clicked')) return; // Prevent multiple clicks
  
          $this.data('clicked', true); // Mark as clicked
          $('#more-payment-options-link').click();
  
          setTimeout(() => {
              $this.removeData('clicked'); // Allow clicking again after delay
          }, 1000); // Adjust delay as needed
      });
  }
  
 $(".product-media-option span").click(function () {
      var mediaListWrapperWidth = $(".product__media-list-wrapper .product__media-list").outerWidth();
      var mediaListWrapperHeight = $(".product__media-list-wrapper .product__media-list").outerHeight();
   
      $(".product-media-option span").removeClass("active");
      $(this).addClass("active");

      if ($(this).hasClass("videos")) {
          $(".product__thumbnail-scroll-shadow, .product__media-list").hide();
          $(".main-video-container, .desktop-thumbnail-container").show();
        
          $(".main-video-container").css({
              width: mediaListWrapperWidth + "px",
              height: mediaListWrapperHeight + "px"
          });
          $(".main-video-container .main-video").css({
              height: mediaListWrapperHeight + "px"
          });
          $(".desktop-thumbnail-container .desktop-thumbnail").css({
              height: mediaListWrapperHeight + "px"
          });
          
      } else {
          $(".product__thumbnail-scroll-shadow, .product__media-list").show();
          $(".main-video-container, .desktop-thumbnail-container").hide();
        
          $(".main-video-container").css({
              width: mediaListWrapperWidth + "px",
              height: mediaListWrapperHeight + "px"
          });
          $(".main-video-container .main-video").css({
              height: mediaListWrapperHeight + "px"
          });
          $(".desktop-thumbnail-container .desktop-thumbnail").css({
              height: mediaListWrapperHeight + "px"
          });
      }
  });
  

  $(function() {
      var galleryTop, galleryThumbs;

      function initSwiper() {
          // Destroy existing Swiper instances if they exist
          if (galleryTop) {
              galleryTop.destroy(true, true);
          }
          if (galleryThumbs) {
              galleryThumbs.destroy(true, true);
          }

          if ($(window).width() > 768) {
              // Initialize Swiper for mobile
              galleryTop = new Swiper(".desktop-thumbnail", {
                  spaceBetween: 10,
                  slidesPerView: 6,
                  direction: "vertical", // Default slides per view for mobile
                  freeMode: false,
                  watchSlidesProgress: true,
                  breakpoints: {
                      768: {
                          slidesPerView: 6
                      },
                      530: {
                          slidesPerView: 6
                      },
                      300: {
                          slidesPerView: 6
                      }
                  }
              });
              galleryThumbs = new Swiper(".main-video", {
                  spaceBetween: 10,
                  navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                  },
                  a11y: {
                      prevSlideMessage: "Previous slide",
                      nextSlideMessage: "Next slide"
                  },
                  thumbs: {
                      swiper: galleryTop
                  }
              });
          } else {
              // Initialize Swiper for desktop
              galleryTop = new Swiper(".thumbnail-mobile", {
                  spaceBetween: 10,
                  slidesPerView: 4,
                  freeMode: false,
                  watchSlidesProgress: true
              });
              galleryThumbs = new Swiper(".main-video", {
                  spaceBetween: 10,
                  navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                  },
                  a11y: {
                      prevSlideMessage: "Previous slide",
                      nextSlideMessage: "Next slide"
                  },
                  thumbs: {
                      swiper: galleryTop
                  }
              });
          }

          // Sync the slide change between galleryTop and galleryThumbs
          galleryTop.on("slideChangeTransitionStart", function() {
              galleryThumbs.slideTo(galleryTop.activeIndex);
          });
          galleryThumbs.on("transitionStart", function() {
              galleryTop.slideTo(galleryThumbs.activeIndex);
          });
      }

      initSwiper();

      // Reinitialize Swiper on window resize
      $(window).resize(function() {
          initSwiper();
        
          $(".main-video-container").css({
              width: mediaListWrapperWidth + "px",
              height: mediaListWrapperHeight + "px"
          });
          $(".main-video-container .main-video").css({
              height: mediaListWrapperHeight + "px"
          });
          $(".desktop-thumbnail-container .desktop-thumbnail").css({
              height: mediaListWrapperHeight + "px"
          });
      });
  });

  
    $('.btn-comparison').click(function(){
      $('.modal-comparison').addClass('active');
    });
    $('.close-modal').click(function(){
      $('.modal-comparison').removeClass('active');
    });

    section_scroll_animation();

});

image_render_scroll();

$(window).on('scroll', function() {
  nav_header_scroll();
  featured_video_animation();
  compatible_section();
  content_show_section();
  hidden_content_selection();
  video_with_slider();
  image_with_slider();
  mash_with_slider();
  image_scrollable_section();
  image_scrollable_second_slide_section();
  image_render_scroll();
  image_with_content_section();
  
});

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function featured_video_animation() {
    if ($('.product-page-featured-video').length) {
        $('.product-page-featured-video').each(function() {
            let el = $(this);
            let video = el.find('video').get(0);
            let timeout;

            // Check if visible and either not played yet or has the 'loop' attribute
            if (visiblePercent(el) > 50) {
                if (!el.data('played') || video.hasAttribute('loop')) {
                    video.play();

                    if (!video.hasAttribute('loop')) {
                        el.data('played', true); // Set the flag only if it’s not looping
                    }

                    // If video has fade-animation attribute and hasn't faded in yet
                    if (video.hasAttribute('fade-animation')) {
                        $(video).addClass('show');

                    }
                }
              
                timeout = setTimeout(() => {
                    el.find('.featured-video-content-container').addClass('show');
                }, 2000); // 2-second delay
            } else {
                video.pause();
            }
        });    
    }
}

function compatible_section(){
  if ($('.product-page-compatible-section').length) {
      $('.product-page-compatible-section').each(function() {
        let el = $(this);
        if (visiblePercent(el) > 50) {
          $(this).find('.bg-elements').addClass('animate');
          $(this).find('.content-text').addClass('animate');
        }

      });    
  }
}


function content_show_section(){
  if ($('.product-page-content-show-section').length) {
      $('.product-page-content-show-section').each(function() {
        let el = $(this);
        if (visiblePercent(el) > 50) {
          $(this).addClass('animate');
        }

      });    
  }
}

function hidden_content_selection(){
  if ($('.product-page-hidden-content-section').length) {
      $('.product-page-hidden-content-section').each(function() {
        let el = $(this);
        let scrolled = visiblePercent(el) * 2;
        if (scrolled >= 80) {
            $(this).find('.element-1').addClass('animate');
        }else{
          $(this).find('.element-1').removeClass('animate');
        }
        if (scrolled >= 100) {
            $(this).find('.element-2').addClass('animate');
        }else{
          $(this).find('.element-2').removeClass('animate');
        }
        if (scrolled >= 130) {
            $(this).find('.element-3').addClass('animate');
        }else{
          $(this).find('.element-3').removeClass('animate');
        }
        if (scrolled >= 150) {
            $(this).find('.section-main-content.desktop .btn.learn-more').addClass('animate');
        }else{
          $(this).find('.section-main-content.desktop .btn.learn-more').removeClass('animate');

          // Toggle the classes when scrolling up below 150
          $('.product-page-hidden-content-section .section-main-content.desktop .btn.learn-more').removeClass('active');
          $('.product-page-hidden-content-section .section-main-content.desktop .container').removeClass('active');
          setTimeout(function() {
              $('.product-page-hidden-content-section .container .right-content-container .description').removeClass('active'); 
          }, 200);
        }
        

      });    
  }
}

function video_with_slider(){
  if ($('.product-page-video-with-slider-section').length) {
      $('.product-page-video-with-slider-section').each(function() {
        let el = $(this);
        let video = el.find('.bg-video').get(0);

        if (visiblePercent(el) > 50) {
            video.play();
        }

      });     
  }
}

function image_with_slider(){
  if ($('.product-page-image-with-slider-section').length) {
      $('.product-page-image-with-slider-section').each(function() {
        let el = $(this);

        if (visiblePercent(el) > 70) {
          $(this).find('.main-section-container').addClass('animate');
        }

        if (visiblePercent(el) > 80) {
          $(this).find('.title-content').addClass('animate');
        }

      });   
  }
}

function mash_with_slider(){
  if ($('.product-page-mask-with-slider-section').length) {
      $('.product-page-mask-with-slider-section').each(function() { 
        let el = $(this); 
        let scrolled = visiblePercent(el) * 2;

        if (scrolled >= 30) {
            let mask = Math.min(Math.max(scrolled - 100, 0), 50);

            // Default to scale 3.5 and opacity 0, decrease after scroll reaches 50%
            let scale = 3.5 - (mask * 0.05); // Decrease scale from 3.5 to 1
            let opacity = Math.min(mask * 0.02, 1); // Increase opacity from 0 to 1

            $('.product-page-mask-with-slider-section .element-mask').css({
                'transform': `scale(${scale})`, 
                'opacity': `${opacity}`
            });
        }
        if (visiblePercent(el) > 80){
            $(this).find('.element-gap').addClass('animate');
        }else{
            $(this).find('.element-gap').removeClass('animate');
        }
        if (visiblePercent(el) > 90){
            $(this).find('.slider-position-container').addClass('animate');
        }else{
            $(this).find('.slider-position-container').removeClass('animate');
        }
        
      });  
  }
}

function image_scrollable_section(){
  if ($('.product-page-image-scrollable-section').length) {
      $('.product-page-image-scrollable-section').each(function() { 
        let el = $(this); 
        if (visiblePercent(el) > 70) {
          $(this).addClass('animate');
        }else{
          $(this).removeClass('animate');
        }
          
      });  
  }
}

function image_scrollable_second_slide_section(){
  if ($('.product-page-image-scrollable-2-section').length) {
      $('.product-page-image-scrollable-2-section').each(function() { 
        let el = $(this); 
        if (visiblePercent(el) > 25) {
          $(this).find('.elements-container').addClass('animate');
        }
        if (visiblePercent(el) > 60) {
          $(this).find('.bg-element.bg-lem-2').addClass('animate');
          $(this).find('.centered-content-container .element-text-1').addClass('slide-up-out');
          $(this).find('.centered-content-container .element-text-2').addClass('slide-up-in');
        }else{
          $(this).find('.bg-element.bg-lem-2').removeClass('animate');
          $(this).find('.centered-content-container .element-text-1').removeClass('slide-up-out');
          $(this).find('.centered-content-container .element-text-2').removeClass('slide-up-in');
        }

        if (visiblePercent(el) > 80) {
          $(this).find('.bg-element.bg-lem-3').addClass('animate');
          $(this).find('.centered-content-container .element-text-2').addClass('slide-up-out');
          $(this).find('.centered-content-container .element-text-3').addClass('slide-up-in');
        }else{
          $(this).find('.bg-element.bg-lem-3').removeClass('animate');
          $(this).find('.centered-content-container .element-text-2').removeClass('slide-up-out');
          $(this).find('.centered-content-container .element-text-3').removeClass('slide-up-in');
        }
        
      });  
  }
}

function image_render_scroll() {
  if ($('.product-page-3d-render-section').length) {
      $('.product-page-3d-render-section').each(function () {
          let el = $(this);
          let scrolled = visiblePercent(el); // Removed * 2 to keep values precise

          let $images = $('.scroll-image-render-container img');
          let totalImages = $images.length;

          if (scrolled < 30) {
              // Before 30% scroll, keep first image active
              $images.removeClass('active');
              $images.first().addClass('active');
          } else {
              // Normalize scroll range from 30% to 100%
              let normalizedScroll = scrolled - 30;
              let maxScroll = 100 - 30; // 70% scroll space

              // Calculate active image index smoothly
              let activeIndex = Math.floor((normalizedScroll / maxScroll) * (totalImages - 1)); // Use totalImages - 1 to avoid blank space
              activeIndex = Math.max(0, Math.min(activeIndex, totalImages - 1)); // Clamp values

              // Apply active class to the correct image
              $images.removeClass('active');
              $images.eq(activeIndex).addClass('active');
          }
          if (visiblePercent(el) > 40){
            $(this).find('.text-content.content-1').addClass('animate');
          }else{
            $(this).find('.text-content.content-1').removeClass('animate');
          }
          if (visiblePercent(el) > 50){
            $(this).find('.text-content.content-2').addClass('animate');
          }else{
            $(this).find('.text-content.content-2').removeClass('animate');
          }
      });
  }
}

function nav_header_scroll(){
  if ($('.product-page-nav-header-section').length) {
      $('.product-page-nav-header-section').each(function () {
        var $container = $(this); 

        // Get the top offset of the .product-header-section
        var productHeaderTop = $('.product-page-nav-header-section').offset().top + 150;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .product-header-section sticky
            $('.main-nav-header-section').addClass('product-header-sticky');
            // Hide the header
            $('#shopify-section-header').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.main-nav-header-section').removeClass('product-header-sticky');
            // Show the header again
            $('#shopify-section-header').removeClass('header-hide');
        }
    
        $container.find('.custom-select-nav').click(function(){
            $(this).toggleClass('active');
        });
        
      });
    
      $(".section-scroll").each(function() {
          var sectionTop = $(this).offset().top - 100;
          var sectionBottom = sectionTop + $(this).outerHeight();
          var scrollPosition = $(window).scrollTop();
          
          var targetButton = $('.product-page-nav-header-section .nav-column.desktop .link-nav span[data-scroll="' + $(this).attr('data-scroll') + '"]');
      
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              targetButton.addClass("active");
              
              // Check if the section has a data-child-scroll attribute
              var childScroll = $(this).attr("data-child-scroll");
              if (childScroll) {
                  $('.product-page-nav-header-section .nav-column.desktop .link-nav span[data-scroll="' + childScroll + '"]').addClass("active");
              }
          } else {
              if (!$(this).attr("data-child-scroll")) {
                  targetButton.removeClass("active");
              }
          }
      });


  }
  

}

function image_with_content_section(){
  if ($('.product-page-image-with-content-section').length) {
      $('.product-page-image-with-content-section').each(function () {
          let el = $(this);
          if (visiblePercent(el) > 70){
              $(this).find('.elements-container').addClass('animate');
          }
      });
  }
}


$('.product-page-nav-header-section').each(function () {
    var $container = $(this); 
    $container.find('.nav-content .link-nav span').click(function(){
      
      
        $('.nav-content .link-nav span').removeClass('active');
        $(this).addClass('active');
        $('.selected-nav').text($(this).text());

      
        var targetAttr = $(this).attr('data-scroll');
        var $targetSection = $('.section-scroll[data-scroll="' + targetAttr + '"]').offset().top - 50;
        $("html, body").animate({
            scrollTop: $targetSection
        }, 1);
    });
});


actionMoreLess();

function actionMoreLess() {
  var boxOuter = ".data_more_less",
      boxInner = ".data_more_less_inner",
      boxBody = ".data_more_less_body",
      showMore = $(".action_more"),
      showLess = $(".action_less");

  $(boxInner).each(function () {
    var $this = $(this),
        bodyDataH = $this.find(boxBody).height(),
        defaultHeight = $this.data("height");

    $this.css("max-height", defaultHeight);

    if (bodyDataH > defaultHeight) {
      $this.closest(boxOuter).removeClass("action_disabled");
    } else {
      $this.closest(boxOuter).addClass("action_disabled");
    }
  });

  showMore.click(function (e) {
    e.preventDefault();
    var $this = $(this),
        $box = $this.closest(boxOuter),
        $inner = $box.find(boxInner);

    $inner.css("max-height", "none");
    $box.addClass("less_active");
  });

  showLess.click(function (e) {
    e.preventDefault();
    var $this = $(this),
        $box = $this.closest(boxOuter),
        $inner = $box.find(boxInner),
        defaultHeight = $inner.data("height");

    $inner.css("max-height", defaultHeight);
    $box.removeClass("less_active");
  });
}


var option_list = document.querySelectorAll('.product-media-option-item');
    option_list.forEach((item) => {
    item.addEventListener('click', (em) => {
        var data_item = item.getAttribute('data-item');
        item.closest('.product-media').querySelectorAll('.main-media').forEach((media_item) => {
            media_item.style.display = 'none';
        });
        item.closest('.product-media').querySelector('.main-media[data-item="'+data_item+'"]').style.display = 'block';
    });
});


$(document).ready(function () {
    $('.main-video-slider').each(function () {
        var $slider = $(this);
        var slideCount = $slider.find('.swiper-slide').length;
        if (slideCount <= 1) {
            $slider.addClass('not-active');
        } else {
            $slider.removeClass('not-active');
        }
    });
});


  $(function() {
    
    function initSwiper() {

        if ($(window).width() > 768) {
            // Initialize Swiper for mobile
            galleryTop = new Swiper(".thumbnail-video-slider", {
                spaceBetween: 10,
                slidesPerView: 6,
            });
            galleryThumbs = new Swiper(".main-video-slider", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                thumbs: {
                    swiper: galleryTop
                }
            });
        }
    }

    initSwiper();

    $(window).resize(function() {
        initSwiper();
        $(".main-video-slider").css({
            height: mediaListWrapperHeight + "px"
        });
        $(".main-video-slider").css({
            height: mediaListWrapperHeight + "px"
        });
    });

  });

  $(function() {
      var galleryTop, galleryThumbs;

      function initSwiper() {
          // Destroy existing Swiper instances if they exist
          if (galleryTop) {
              galleryTop.destroy(true, true);
          }
          if (galleryThumbs) {
              galleryThumbs.destroy(true, true);
          }

          if ($(window).width() > 768) {
              // Initialize Swiper for mobile
              galleryTop = new Swiper(".desktop-thumbnail", {
                  spaceBetween: 10,
                  slidesPerView: 6,
                  direction: "vertical", // Default slides per view for mobile
                  freeMode: false,
                  watchSlidesProgress: true,
                  breakpoints: {
                      768: {
                          slidesPerView: 6
                      },
                      530: {
                          slidesPerView: 6
                      },
                      300: {
                          slidesPerView: 6
                      }
                  }
              });
              galleryThumbs = new Swiper(".main-video", {
                  spaceBetween: 10,
                  navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                  },
                  a11y: {
                      prevSlideMessage: "Previous slide",
                      nextSlideMessage: "Next slide"
                  },
                  thumbs: {
                      swiper: galleryTop
                  }
              });
          } else {
              // Initialize Swiper for desktop
              galleryTop = new Swiper(".thumbnail-mobile", {
                  spaceBetween: 10,
                  slidesPerView: 4,
                  freeMode: false,
                  watchSlidesProgress: true
              });
              galleryThumbs = new Swiper(".main-video", {
                  spaceBetween: 10,
                  navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                  },
                  a11y: {
                      prevSlideMessage: "Previous slide",
                      nextSlideMessage: "Next slide"
                  },
                  thumbs: {
                      swiper: galleryTop
                  }
              });
          }

          // Sync the slide change between galleryTop and galleryThumbs
          galleryTop.on("slideChangeTransitionStart", function() {
              galleryThumbs.slideTo(galleryTop.activeIndex);
          });
          galleryThumbs.on("transitionStart", function() {
              galleryTop.slideTo(galleryThumbs.activeIndex);
          });
      }

      initSwiper();

      // Reinitialize Swiper on window resize
      $(window).resize(function() {
          initSwiper();
        
          $(".main-video-container").css({
              width: mediaListWrapperWidth + "px",
              height: mediaListWrapperHeight + "px"
          });
          $(".main-video-container .main-video").css({
              height: mediaListWrapperHeight + "px"
          });
          $(".desktop-thumbnail-container .desktop-thumbnail").css({
              height: mediaListWrapperHeight + "px"
          });
      });
  });